module.exports = __webpack_public_path__ + "media/photo/development1-36b067ac.png";